//IMPORTAÇÃO DAS BIBLIOTECAS---------------------------------------------------
import React, { useEffect, useState, useRef } from "react";
import { ClipLoader } from "react-spinners";
import { api } from "../../services/api";
import { useTranslation } from 'react-i18next';
import { FaArrowLeft, FaTag, FaCheckCircle, FaTimes, FaChevronDown } from 'react-icons/fa';
import { Link } from "react-router-dom";



//IMPORTAÇÃO DOS COMPONENTES---------------------------------------------------
import styles from "./payments.module.css";
import imgMP from '../../img/mp_logo.webp';
import imgStripe from '../../img/stp_logo.png';
import imgPix from '../../img/pix_logo.png';
import { useAppContext } from "../../AppContext.js";
import ComponentLoad from "../../components/componentLoad/componentLoad.js";



// HOOK DE ANIMAÇÃO DE NÚMEROS---------------------------------------------------
function useAnimatedNumber(targetValue, duration = 800) {
    const [value, setValue] = useState(targetValue);
    const valueRef = useRef(targetValue);

    useEffect(() => {
        let startTimestamp = null;
        const startValue = valueRef.current;
        let animationFrame;

        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);

            // easeOutExpo
            const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            const currentAnimatedValue = startValue + (targetValue - startValue) * easeProgress;

            setValue(currentAnimatedValue);
            valueRef.current = currentAnimatedValue;

            if (progress < 1) {
                animationFrame = window.requestAnimationFrame(step);
            } else {
                setValue(targetValue);
                valueRef.current = targetValue;
            }
        };

        animationFrame = window.requestAnimationFrame(step);

        return () => window.cancelAnimationFrame(animationFrame);
    }, [targetValue, duration]);

    return value;
}



//COMPONENTE-------------------------------------------------------------------
export default function Payments() {
    const { t } = useTranslation(); // função para tradução
    const { isApp } = useAppContext(); // define se está sendo acessado pelo app ou pelo site

    // VARIÁVEIS DE ESTADO-----------------------------------------------------

    // Carregamento da página
    const [componentLoading, setComponentLoading] = useState(true); // load para aguardar carregamento completo da página
    const [errorLoad, setErrorLoad] = useState(false); // erro ao carregar página
    const [validityPayment, setValidityPayment] = useState(true); // impede o usuário adquirir plano caso o plano atual com validade superior ao tempo minimo para liberação de compra de plano
    const [payPendingConfirmation, setPayPendingConfirmation] = useState(false); // aviso de que existe pagamento pendente não verificado
    const [userModifyCurrencyCoin, setUserModifyCurrencyCoin] = useState(false); // permite ou não usuário modificar moeda

    // Planos e preços
    const [selectedPlan, setSelectedPlan] = useState("Mensal"); // 'Mensal' | 'Anual'
    const [prices, setPrices] = useState({ Mensal: 0, Anual: 0 }); // preços dos planos
    const [regiaoPayment, setRegiaoPayment] = useState("pt-BR"); // região do pagamento
    const [currency, setCurrency] = useState("BRL"); // moeda do pagamento
    const [nameCoin, setNameCoin] = useState("Real Brasileiro"); // nome da moeda

    // desconto anual automático
    const [anualPercentageDiscount, setAnualPercentageDiscount] = useState(0); // desconto anual automático

    // metodo de pagamento
    const [method, setMethod] = useState("pix"); // 'pix' | 'mercadopago' | 'stripe'

    // pagamento pix
    const [loading, setLoading] = useState(false); // load para aguardar dados do pix (backend)
    const [pixData, setPixData] = useState(null); // dados do pix
    const [error, setError] = useState(null); // erro
    const [copied, setCopied] = useState(false); // copia do pix

    // cupons
    const [couponInput, setCouponInput] = useState(""); // input do cupom
    const [appliedCoupon, setAppliedCoupon] = useState(null); // cupom aplicado
    const [couponError, setCouponError] = useState(""); // erro do cupom
    const [showAvailableCoupons, setShowAvailableCoupons] = useState(false); // mostrar/ocultar cupons disponíveis
    const [availableCoupons, setAvailableCoupons] = useState([]); // cupons disponíveis para o usuário

    // configurações de preços e descontos
    const basePrice = Number(prices[selectedPlan]) || 0;
    const discountAmount = appliedCoupon ? (basePrice * (appliedCoupon.discount / 100)) : 0;
    const finalPrice = Math.max(0, basePrice - discountAmount);

    // define região para formatação de preços
    const [region, setRegion] = useState("BR") // para definir formatação de preços e se pix fica disponível

    // valores finais animados para suavidade nas mudanças
    const animatedFinalPrice = useAnimatedNumber(finalPrice);

    // formatação de preços finais com base na região
    const valorFinal = animatedFinalPrice.toLocaleString(regiaoPayment, { style: 'currency', currency: currency });

    // formatação de preços originais com base na região
    const originalFinal = basePrice.toLocaleString(regiaoPayment, { style: 'currency', currency: currency });

    // formatação de descontos com base na região
    const discountFinal = discountAmount.toLocaleString(regiaoPayment, { style: 'currency', currency: currency });

    // preço final caso usuário queira usar outra moeda
    const [localeCurrencyMap, setLocaleCurrencyMap] = useState({}); // mapa para montar options de moedas caso usuário queira usar mmoedad diferente da região
    const [userChangeCurrency, setUserChangeCurrency] = useState(false); // usuário optou por usar outra moeda

    // estados para animação suave entre troca de moedas
    const [fadeTotal, setFadeTotal] = useState(false);

    // estado que deriva se a moeda alternativa deve ser usada com base na escolha do usuário e no método selecionado (stripe)
    const shouldUseAlternateCurrency = userChangeCurrency && method === "stripe";
    const [displayCurrencyMode, setDisplayCurrencyMode] = useState(shouldUseAlternateCurrency);

    const [pricesDefault, setPricesDefault] = useState({ Mensal: 0, Anual: 0 }); // preços originais dos planos
    const [pricesDefaultUserChangeCurrency, setPricesDefaultUserChangeCurrency] = useState({ Mensal: 0, Anual: 0 }); // preços originais dos planos convertidos para a moeda selecionada

    // desconto anual automático
    const [anualPercentageDiscountUserChangeCurrency, setAnualPercentageDiscountUserChangeCurrency] = useState(0); // desconto anual automático

    const [currencyUserChange, setCurrencyUserChange] = useState("USD"); // moeda selecionada
    const [regionUserChange, setRegionUserChange] = useState("en-US"); // região selecionada
    const [regionUserChangeCode, setRegionUserChangeCode] = useState("US"); // código da região selecionada
    const [nameCoinUserChange, setNameCoinUserChange] = useState("Dólar"); // nome da moeda selecionada
    const [valorFinalUserChangeCurrency, setValorFinalUserChangeCurrency] = useState(0);
    const animatedValorFinalUserChangeCurrency = useAnimatedNumber(valorFinalUserChangeCurrency);

    // formatação de preços originais e descontos caso usuário mude a moeda
    const basePriceUserChangeCurrency = Number(pricesDefaultUserChangeCurrency[selectedPlan]) || 0;
    const discountAmountUserChangeCurrency = appliedCoupon ? (basePriceUserChangeCurrency * (appliedCoupon.discount / 100)) : 0;
    const originalFinalUserChangeCurrency = basePriceUserChangeCurrency.toLocaleString(regionUserChange, { style: 'currency', currency: currencyUserChange });
    const discountFinalUserChangeCurrency = discountAmountUserChangeCurrency.toLocaleString(regionUserChange, { style: 'currency', currency: currencyUserChange });



    // BUSCAR DADOS INICIAIS---------------------------------------------------------
    // dados financeiros
    useEffect(() => {
        (async () => {
            try {
                const res = await api.get("/payments/getDataPlan");
                if (res?.data) {
                    setPrices(res.data.prices ? { Mensal: res.data.prices.valor1Convertido, Anual: res.data.prices.valor2Convertido } : { Mensal: 0, Anual: 0 });
                    setPricesDefault(res.data.prices ? { Mensal: res.data.prices.valorBase1, Anual: res.data.prices.valorBase2 } : { Mensal: 0, Anual: 0 });
                    setPricesDefaultUserChangeCurrency(res.data.prices ? { Mensal: res.data.prices.valorBase1, Anual: res.data.prices.valorBase2 } : { Mensal: 0, Anual: 0 });
                    setRegiaoPayment(res.data.prices.region);
                    setCurrency(res.data.prices.currency);
                    setNameCoin(res.data.prices.name);
                    setLocaleCurrencyMap(res.data.prices.localeCurrencyMap);

                    // setar as variáveis de mudança de moeda com o mesmo valor inicial
                    setRegionUserChangeCode(res.data.prices.regionCode);
                    setCurrencyUserChange(res.data.prices.currency);
                    setRegionUserChange(res.data.prices.region);
                    setNameCoinUserChange(res.data.prices.name);

                    setPayPendingConfirmation(res.data.payPendingConfirmation ?? false);
                    setAvailableCoupons(res.data.coupons ?? []);
                    // caso não possa comprar plano
                    if (res.data.validityPayment === false) {
                        setValidityPayment(false);
                    }

                    // permite ou não usuário modificar moeda
                    setUserModifyCurrencyCoin(res.data.userModifyCurrencyCoin ?? false);

                    // calcular a porcentagem de desconto anual automático com base no preço mensal
                    const vAnualCheio = res.data.prices.valor1Convertido * 12;
                    const percentageDiscount = Math.round(((vAnualCheio - res.data.prices.valor2Convertido) / vAnualCheio) * 100);

                    setAnualPercentageDiscount(percentageDiscount);

                    // calcular a porcentagem de desconto anual automático com base no preço mensal para outra moeda
                    const vAnualCheioUserChangeCurrency = res.data.prices.valor1Convertido * 12;
                    const percentageDiscountUserChangeCurrency = Math.round(((vAnualCheioUserChangeCurrency - res.data.prices.valor2Convertido) / vAnualCheioUserChangeCurrency) * 100);

                    setAnualPercentageDiscountUserChangeCurrency(percentageDiscountUserChangeCurrency);

                    setComponentLoading(false);
                }
            } catch (err) {
                //console.error("Erro ao buscar plano atual:", err.response?.data ?? err.message); // somente para desenvolvimento
                setErrorLoad(true);
                setComponentLoading(false);
            }
        })();
    }, []);


    // configurações de preço final caso usuário queira usar outra moeda
    const configFinalUserChangeCurrency = React.useCallback(async (regionCode) => {
        const currencyInfo = localeCurrencyMap[regionCode];

        setCurrencyUserChange(currencyInfo.currency);
        setRegionUserChangeCode(currencyInfo.regionCode);
        setRegionUserChange(currencyInfo.region);
        setNameCoinUserChange(currencyInfo.name);

        const precoSelecionado = pricesDefault[selectedPlan] * currencyInfo.aplliedRate;
        const discountAmt = appliedCoupon ? (precoSelecionado * (appliedCoupon.discount / 100)) : 0;
        const finalPrc = Math.max(0, precoSelecionado - discountAmt);

        const priceMensalUserChangeCurrency = pricesDefault.Mensal * currencyInfo.aplliedRate;
        const priceAnualUserChangeCurrency = pricesDefault.Anual * currencyInfo.aplliedRate;
        setPricesDefaultUserChangeCurrency({ Mensal: priceMensalUserChangeCurrency, Anual: priceAnualUserChangeCurrency });

        // calcular a porcentagem de desconto anual automático com base no preço mensal para outra moeda
        const vAnualCheioUserChangeCurrency2 = priceMensalUserChangeCurrency * 12;
        const percentageDiscountUserChangeCurrency = Math.round(((vAnualCheioUserChangeCurrency2 - priceAnualUserChangeCurrency) / vAnualCheioUserChangeCurrency2) * 100);
        setAnualPercentageDiscountUserChangeCurrency(percentageDiscountUserChangeCurrency);

        setValorFinalUserChangeCurrency(finalPrc);
    }, [localeCurrencyMap, pricesDefault, selectedPlan, appliedCoupon]);

    // Calcula o preço caso usuário mude os dados do pagamento (planos, cupons ou mude para moeda local)
    useEffect(() => {
        if (userChangeCurrency && regionUserChangeCode && localeCurrencyMap[regionUserChangeCode]) {
            configFinalUserChangeCurrency(regionUserChangeCode);
        }
    }, [userChangeCurrency, regionUserChangeCode, localeCurrencyMap, configFinalUserChangeCurrency]);


    // Transição suave ao trocar de moeda ou selecionar/deselecionar stripe
    useEffect(() => {
        if (shouldUseAlternateCurrency !== displayCurrencyMode) {
            setFadeTotal(true); // inicia o fade out
            const timeout = setTimeout(() => {
                setDisplayCurrencyMode(shouldUseAlternateCurrency); // atualiza o estado que é renderizado
                setFadeTotal(false); // inicia o fade in
            }, 600); // duração do desaparecimento
            return () => clearTimeout(timeout);
        }
    }, [shouldUseAlternateCurrency, displayCurrencyMode]);



    // idioma e região
    useEffect(() => {
        if (regiaoPayment === "pt-BR") {
            setRegion("BR");
        } else {
            setRegion("US");
        }
    }, [regiaoPayment]);



    // configura escolha inicial do metodo de pagemento com base na região
    useEffect(() => {
        if (region === "BR") {
            setMethod("pix");
        } else {
            setMethod("stripe");
        }
    }, [region]);



    // CONFIGURAÇÕES PIX-------------------------------------------------------------
    // hook para resetar dados do pix e erro
    useEffect(() => {
        setPixData(null);
        setError(null);
        setCopied(false);
    }, [selectedPlan, method]);

    // criar pagamento pix
    const handleCreatePix = async () => {
        setError(null);
        setPixData(null);
        setCopied(false);
        setLoading(true);
        try {
            const res = await api.post("/payments/pix", { description: selectedPlan, coupon: appliedCoupon });
            setPayPendingConfirmation(true);
            setPixData(res.data);
        } catch (err) {
            //console.error("Erro ao criar pagamento pix:", err.response?.data ?? err.message); // somente para desenvolvimento
            setError(t("Error generating PIX QR code. Please try again."));
        } finally {
            setLoading(false);
        }
    };

    // copiar código pix
    const copyBrCode = async () => {
        if (!pixData?.brCode) return;
        try {
            await navigator.clipboard.writeText(pixData.brCode);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        } catch (e) {
            setError(t("Failed to copy PIX code. Please try again."));
        }
    };
    // ------------------------------------------------------------------------------



    // CONFIGURAÇÕES CUPONS----------------------------------------------------------
    // aplicar cupom
    const handleApplyCoupon = (code) => {
        setCouponError("");

        if (!code) {
            setCouponError(t("Please enter a coupon code."));
            return;
        }

        const upperCode = code.toUpperCase();
        const found = availableCoupons.find(c => c.code === upperCode);

        if (found) {
            setAppliedCoupon(found);
            setCouponInput("");
        } else {
            setCouponError(t("Invalid or expired coupon."));
        }
    };

    // remover cupom
    const handleRemoveCoupon = () => {
        setAppliedCoupon(null);
        setCouponError("");
    };
    // ------------------------------------------------------------------------------



    // CONFIGURAÇÕES PAGAMENTOS POR OUTROS MÉTODOS-----------------------------------
    // criar pagamento por outros métodos
    const handleProvider = async (provider) => {
        setError(null);
        setLoading(true);
        try {
            const bodyData = { description: selectedPlan, coupon: appliedCoupon };
            if (provider === "stripe" && userChangeCurrency) {
                bodyData.userRegionCode = regionUserChangeCode;
            }
            const res = await api.post(`/payments/${provider}`, bodyData);
            if (res?.data?.url) {
                window.open(res.data.url, "_blank");
                setPayPendingConfirmation(true);
            } else {
                setError(t("Unexpected response from the payment provider."));
            }
        } catch (err) {
            setError(t("Error initiating payment. Please try again."));
        } finally {
            setLoading(false);
        }
    };
    // ------------------------------------------------------------------------------



    // CONFIGURAÇÕES GERAIS----------------------------------------------------------
    const handleCheckoutAction = async () => {
        if (method === "pix") {
            await handleCreatePix();
        } else {
            await handleProvider(method);
        }
    }
    // ------------------------------------------------------------------------------



    // TELA DE CARREGAMENTO
    if (componentLoading) {
        return (
            <div className={styles.loadingContainer}>
                <ComponentLoad />
            </div>
        );
    }



    // TELA DE ERRO
    if (errorLoad) {
        return (
            <div className={styles.container}>
                <div className={`${styles.header} ${isApp ? styles.headerApp : ''}`}>
                    <Link className={styles.backButton} to="/notepad">
                        <FaArrowLeft /> {t("Back")}
                    </Link>
                </div>
                <div className={styles.errorContainer}>
                    <div className={styles.card}>
                        <h2 className={styles.errorTitle}>{t("Error loading page.")}</h2>
                        <p className={styles.errorDescription}>{t("Please try again later.")}</p>
                        <button className={styles.retryButton} onClick={() => window.location.reload()}>{t("Reload")}</button>
                    </div>
                </div>
            </div>
        );
    }



    // MOSTRA O AVISO DE PLANO ATIVO E IMPOSSIBILIDADE DE GERAR NOVO PAGAMENTO
    if (!validityPayment) {
        return (
            <div className={styles.container}>
                <div className={`${styles.header} ${isApp ? styles.headerApp : ''}`}>
                    <Link className={styles.backButton} to="/notepad">
                        <FaArrowLeft /> {t("Back")}
                    </Link>
                </div>
                <div className={styles.contentWrapper}>
                    <div className={styles.card} style={{ width: '100%', textAlign: 'center', padding: '64px' }}>
                        <h2>{t("Your plan is active. Enjoy all available features!")}</h2>
                        <p>{t("Contact support if you wish to change your plan.")}</p>
                    </div>
                </div>
            </div>
        )
    }



    // TELA DE PAGAMENTO
    return (
        <div className={styles.container}>

            {/* Header */}
            <div className={`${styles.header} ${isApp ? styles.headerApp : ''}`}>
                <Link to="/notepad" className={styles.backButton}>
                    <FaArrowLeft /> {t("Back")}
                </Link>
            </div>

            <div className={`${styles.contentWrapper} ${isApp ? styles.contentWrapperApp : ''}`}>
                <div className={styles.mainColumn}>

                    {/* aviso de pagamento pendente */}
                    {payPendingConfirmation && (
                        <div className={styles.card} style={{ backgroundColor: '#fff9e6', borderLeft: '4px solid #f29e02' }}>
                            <p style={{ margin: 0, color: '#b27400', fontWeight: 'bold' }}>
                                {t("You have a pending payment confirmation. Please wait for processing!")}
                            </p>
                        </div>
                    )}

                    {/* Error Message */}
                    {error && (
                        <div className={styles.errorMsg}>
                            {error}
                        </div>
                    )}

                    {pixData?.qrcodeDataUrl ? (

                        // painel de pagamento via PIX
                        <div className={styles.card}>
                            <h2 className={styles.sectionTitle}>{t("Pay with PIX")}</h2>
                            <div className={styles.pixContainer}>
                                <p>{t("Scan this QR Code with your bank app:")}</p>
                                <div className={styles.pixQr}>
                                    <img src={pixData.qrcodeDataUrl} alt="QR PIX" width="200" height="200" />
                                </div>
                                <p style={{ fontSize: 14, color: '#666' }}>TXID: {pixData.txid}</p>
                                <p style={{ fontSize: 14, color: '#666', marginBottom: 16 }}>
                                    {t("Expires at")}: {pixData.expiresAt ? new Date(pixData.expiresAt).toLocaleString() : "—"}
                                </p>

                                <textarea
                                    className={styles.pixCodeBox}
                                    readOnly
                                    value={pixData.brCode}
                                />

                                <button type="button" className={styles.copyButton} onClick={copyBrCode}>
                                    {copied ? t("Copied!") : t("Copy PIX Code")}
                                </button>
                            </div>
                        </div>

                    ) : (
                        <>
                            {/* Plan Selection */}
                            <div className={styles.card}>
                                <h2 className={styles.sectionTitle}>{t("Choose a plan")}</h2>
                                <div className={styles.optionsList}>
                                    <div
                                        className={`${styles.optionItem} ${selectedPlan === "Mensal" ? styles.selected : ""}`}
                                        onClick={() => setSelectedPlan("Mensal")}
                                    >
                                        <div className={styles.optionRadio}></div>
                                        <div className={styles.optionContent}>
                                            <div className={styles.optionTitle}>{t("Monthly Plan")}</div>
                                            <div className={styles.optionSubtitle}>{t("Pay monthly")}</div>
                                        </div>
                                        <div className={styles.optionRight}>
                                            {method === "stripe" && userChangeCurrency ? (
                                                Number(pricesDefaultUserChangeCurrency.Mensal).toLocaleString(regionUserChange, { style: 'currency', currency: currencyUserChange })
                                            ) : (
                                                Number(prices.Mensal).toLocaleString(regiaoPayment, { style: 'currency', currency: currency })
                                            )}
                                        </div>
                                    </div>

                                    <div
                                        className={`${styles.optionItem} ${selectedPlan === "Anual" ? styles.selected : ""}`}
                                        onClick={() => setSelectedPlan("Anual")}
                                    >
                                        <div className={styles.optionRadio}></div>
                                        <div className={styles.optionContent}>
                                            <div className={styles.optionTitle}>{t("Annual Plan")}</div>

                                            {/* Se tiver desconto */}
                                            {anualPercentageDiscount > 0 || anualPercentageDiscountUserChangeCurrency > 0 ? (
                                                <div className={styles.optionSubtitle}>
                                                    {method === "stripe" && userChangeCurrency ? (
                                                        <>
                                                            {anualPercentageDiscountUserChangeCurrency > 0 && (
                                                                <>
                                                                    <span className={styles.highlight}>{t("Best value")}</span> · {t("Save ") + anualPercentageDiscountUserChangeCurrency + "%"}
                                                                </>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {anualPercentageDiscount > 0 && (
                                                                <>
                                                                    <span className={styles.highlight}>{t("Best value")}</span> · {t("Save ") + anualPercentageDiscount + "%"}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className={styles.optionSubtitle}>
                                                    <div className={styles.optionSubtitle}>{t("Pay yearly")}</div>
                                                </div>
                                            )}

                                        </div>
                                        <div className={styles.optionRight}>
                                            {method === "stripe" && userChangeCurrency ? (
                                                Number(pricesDefaultUserChangeCurrency.Anual).toLocaleString(regionUserChange, { style: 'currency', currency: currencyUserChange })
                                            ) : (
                                                Number(prices.Anual).toLocaleString(regiaoPayment, { style: 'currency', currency: currency })
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Coupons Section */}
                            <div className={styles.card}>
                                <h2 className={styles.sectionTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <FaTag size={18} color="#009ee3" /> {t("Coupons & Discounts")}
                                </h2>

                                {!appliedCoupon ? (
                                    <>
                                        <div className={styles.couponInputGroup}>
                                            <input
                                                type="text"
                                                className={styles.couponInput}
                                                placeholder={t("Enter coupon code")}
                                                value={couponInput}
                                                onChange={(e) => {
                                                    setCouponInput(e.target.value);
                                                    setCouponError("");
                                                }}
                                            />
                                            <button
                                                className={styles.applyBtn}
                                                onClick={() => handleApplyCoupon(couponInput)}
                                                disabled={!couponInput.trim()}
                                            >
                                                {t("Apply")}
                                            </button>
                                        </div>
                                        {couponError && <p className={`${styles.msgSmall} ${styles.error}`}>{couponError}</p>}

                                        {availableCoupons.length > 0 && (
                                            <div className={styles.availableCouponsWrapper}>
                                                <button
                                                    className={styles.toggleCouponsBtn}
                                                    onClick={() => setShowAvailableCoupons(!showAvailableCoupons)}
                                                >
                                                    <div className={styles.toggleCouponsBtnLeft}>
                                                        <FaTag size={16} />
                                                        {showAvailableCoupons ? t("Hide available coupons") : t("View available coupons")}
                                                    </div>
                                                    <FaChevronDown className={`${styles.chevron} ${showAvailableCoupons ? styles.chevronUp : ""}`} />
                                                </button>

                                                <div className={`${styles.availableCouponsList} ${showAvailableCoupons ? styles.show : ""}`}>
                                                    <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: '#444' }}>
                                                        {t("Available for you:")}
                                                    </p>
                                                    {availableCoupons.map((coupon, idx) => (
                                                        <div key={idx} className={styles.availableCouponItem}>
                                                            <div className={styles.couponInfo}>
                                                                <div className={styles.couponHeaderRow}>
                                                                    <span className={styles.couponBadge}>{coupon.code}</span>
                                                                    <span style={{ fontSize: 13, color: '#00a650', fontWeight: 'bold' }}>-{coupon.discount}%</span>
                                                                </div>
                                                                <span className={styles.couponDesc}>{coupon.description}</span>
                                                            </div>
                                                            <button
                                                                className={styles.useCouponBtn}
                                                                onClick={() => {
                                                                    handleApplyCoupon(coupon.code);
                                                                    setShowAvailableCoupons(false);
                                                                }}
                                                            >
                                                                {t("Use")}
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div className={styles.appliedCouponCard}>
                                        <div className={styles.appliedCouponRow}>
                                            <FaCheckCircle className={styles.appliedIcon} />
                                            <div>
                                                <div style={{ fontWeight: 600, color: '#0284c7', fontSize: 16 }}>
                                                    {appliedCoupon.code} <span style={{ color: '#00a650' }}>(-{appliedCoupon.discount}%)</span>
                                                </div>
                                                <div style={{ fontSize: 13, color: '#666', marginTop: 2 }}>{t("Coupon applied successfully!")}</div>
                                            </div>
                                        </div>
                                        <button className={styles.removeCouponBtn} onClick={handleRemoveCoupon}>
                                            <FaTimes size={12} style={{ marginRight: 4 }} /> {t("Remove")}
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* Payment Options */}
                            <div className={styles.card}>
                                <h2 className={styles.sectionTitle}>{t("How do you want to pay?")}</h2>
                                <div className={styles.optionsList}>
                                    {/* método pix */}
                                    {region === "BR" && (
                                        <div
                                            className={`${styles.optionItem} ${method === "pix" ? styles.selected : ""}`}
                                            onClick={() => setMethod("pix")}
                                        >
                                            <div className={styles.optionRadio}></div>
                                            <img src={imgPix} alt="Pix" className={styles.optionImage} onError={(e) => e.target.style.display = 'none'} />
                                            <div className={styles.optionContent}>
                                                <div className={styles.optionTitle}>PIX</div>
                                                <div className={styles.optionSubtitle}>
                                                    <span className={styles.highlight}>{t("Instant approval")}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* método mercado pago */}
                                    {region === "BR" && (
                                        <div
                                            className={`${styles.optionItem} ${method === "mercadopago" ? styles.selected : ""}`}
                                            onClick={() => setMethod("mercadopago")}
                                        >
                                            <div className={styles.optionRadio}></div>
                                            {/* Optional Logo image instead of text if preferred */}
                                            <img src={imgMP} alt="Mercado Pago" className={styles.optionImage} onError={(e) => e.target.style.display = 'none'} />
                                            <div className={styles.optionContent}>
                                                <div className={styles.optionTitle}>Mercado Pago</div>
                                                <div className={styles.optionSubtitle}>{t("Cards, Wallet, and more")}</div>
                                            </div>
                                        </div>
                                    )}

                                    {/* método stripe */}
                                    <div
                                        className={`${styles.optionItem} ${method === "stripe" ? styles.selected : ""}`}
                                        onClick={() => setMethod("stripe")}
                                    >
                                        <div className={styles.optionRadio}></div>
                                        <img src={imgStripe} alt="Stripe" className={styles.optionImage} onError={(e) => e.target.style.display = 'none'} />
                                        <div className={styles.optionContent}>
                                            <div className={styles.optionTitle}>Stripe</div>
                                            <div className={styles.optionSubtitle}>{t("International Credit Cards")}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className={styles.summaryColumn}>

                    {/* painel de resumo do pagamento */}
                    <div className={styles.card}>
                        <h2 className={styles.sectionTitle}>{t("Purchase summary")}</h2>

                        {/* plano */}
                        <div className={styles.summaryRow}>
                            <span>{t("Plan")}</span>
                            <span>{selectedPlan === "Mensal" ? t("Monthly") : t("Annual")}</span>
                        </div>

                        {/* desconto */}
                        {appliedCoupon && (
                            <>
                                <div className={styles.summaryRow} style={{ marginTop: 8 }}>
                                    <span>{t("Price")}</span>
                                    <span className={fadeTotal ? styles.hidden : styles.visible} style={{ textDecoration: 'line-through', color: '#999' }}>
                                        {displayCurrencyMode ? originalFinalUserChangeCurrency : originalFinal}
                                    </span>
                                </div>
                                <div className={styles.discountRow} style={{ marginTop: 4 }}>
                                    <span>{t("Discount")} (-{appliedCoupon.discount}%)</span>
                                    <span className={fadeTotal ? styles.hidden : styles.visible}>
                                        - {displayCurrencyMode ? discountFinalUserChangeCurrency : discountFinal}
                                    </span>
                                </div>
                            </>
                        )}

                        <div className={styles.summaryDivider}></div>

                        {/* total */}
                        <div className={`${styles.summaryRow} ${styles.total}`}>
                            <span>{t("You pay")}</span>
                            <span className={`${styles.totalValue} ${fadeTotal ? styles.hidden : styles.visible}`}>
                                {displayCurrencyMode ? animatedValorFinalUserChangeCurrency.toLocaleString(regionUserChange, { style: 'currency', currency: currencyUserChange }) : valorFinal}
                            </span>
                        </div>

                        {/* nome da moeda */}
                        <div className={`${styles.nameCoin} ${fadeTotal ? styles.hidden : styles.visible}`}>
                            {displayCurrencyMode ? nameCoinUserChange : nameCoin}
                        </div>

                        {/* select de moedas */}
                        {/* caixa de escolha "quero usar outra moeda para pagamento?" */}
                        {userModifyCurrencyCoin && method === "stripe" && (
                            <div className={styles.selectCurrencyContainer}>
                                <input
                                    checked={userChangeCurrency}
                                    type="checkbox"
                                    id="currency"
                                    name="currency"
                                    onChange={(e) => setUserChangeCurrency(e.target.checked)}
                                />
                                <label htmlFor="currency">{t("Want to use another currency for payment?")}</label>
                            </div>
                        )}

                        {/* moedas disponíveis para pagamento */}
                        {userModifyCurrencyCoin && userChangeCurrency && method === "stripe" && (
                            <select
                                value={regionUserChangeCode}
                                onChange={(e) => {
                                    configFinalUserChangeCurrency(e.target.value);
                                }}
                                className={styles.selectCurrency}
                            >
                                {Object.values(localeCurrencyMap)
                                    .map((value) => (
                                        <option key={value.regionCode} value={value.regionCode}>
                                            {value.country} - {value.name}
                                        </option>
                                    ))}
                            </select>
                        )}

                        {/* botão de pagamento */}
                        {!pixData?.qrcodeDataUrl && (
                            <button
                                className={styles.payButton}
                                onClick={handleCheckoutAction}
                                disabled={loading}
                            >
                                {loading ? (
                                    <ClipLoader color="#ffffff" size={20} />
                                ) : method === "pix" ? (
                                    t("Generate PIX")
                                ) : (
                                    `${t("Pay with")} ${method === "stripe" ? "Stripe" : "Mercado Pago"}`
                                )}
                            </button>
                        )}
                        {pixData?.qrcodeDataUrl && (
                            <button
                                className={styles.payButton}
                                onClick={() => { setPixData(null); setLoading(false); }}
                                style={{ background: '#fff', color: '#009ee3', border: '1px solid #009ee3' }}
                            >
                                {t("Cancel")}
                            </button>
                        )}

                    </div>

                    {/* painel para mostrar figuras */}
                    <div className={styles.logosContainer}>
                        {method === "stripe" && (
                            <img src={imgStripe} alt="Stripe" className={styles.optionImage} onError={(e) => e.target.style.display = 'none'} />
                        )}
                        {method === "mercadopago" && (
                            <img src={imgMP} alt="Mercado Pago" className={styles.optionImage} onError={(e) => e.target.style.display = 'none'} />
                        )}
                        {method === "pix" && (
                            <img src={imgPix} alt="PIX" className={styles.optionImage} onError={(e) => e.target.style.display = 'none'} />
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}

